
<template>
  <div id="home-content">
    <div class="reference-bar">
      <div class="home-icon">
        <img
          src="@/assets/images/icon-compare.png"
          style="width: 76px;"
          alt="Compare Flights and Save"
        />
        <p style="font-weight: bold;margin-top: 10px;">
          Easily compare and save
        </p>
        <p style="font-weight: normal; color: #555;">Low cost carriers</p>
      </div>
      <div class="home-icon">
        <img
          src="@/assets/images/icon-support.png"
          style="width: 70px;"
          alt="Call center support"
        />
        <p style="font-weight: bold;margin-top: 10px;">24/7/365 Support</p>
        <p style="font-weight: normal; color: #555;">
          Free call centre support
        </p>
      </div>
      <div class="home-icon">
        <img
          src="@/assets/images/icon-pnp.png"
          style="width:168px; margin: 20px 0;"
          alt="Book Online and Pay in Store"
        />
        <p style="font-weight: bold;">Book online &amp; pay in-store</p>
        <p style="font-weight: normal; color: #555;">
          <a
            target="_self"
            href="https://travel.flightsite.co.za/travel/pick-n-pay-book-online-pay-store/"
            >Find out more</a
          >
        </p>
      </div>
    </div>

    <div class="row " :style="welcomeCSS" style="margin-top: 30px;">
      <div
        style="padding: 30px; color: #fff; position: static;"
        class="col-md-6"
      >
        <div class="header_container">
          <span style="font-size: 30px; color: #fff;">Welcome to</span><br />
          <span class="large_header" style="color: #fff;">Flightsite</span>
        </div>
      </div>
      <div
        style="padding: 30px; color: #fff; background-color: rgba(0,0,0,0.5); position: static;"
        class="col-md-6 text_overlay"
      >
        <p
          style="margin: 0 0 10px; line-height: 20px; font-family: 'Open Sans' sans-serif; color: white;"
        >
          Welcome to FlightSite, your one-stop destination for travel bookings,
          expert advice and excellent prices. From flight bookings to travel
          packages and accommodation, our team of consultants have the whole
          spectrum covered.
        </p>
        <p
          style="margin: 0 0 10px; line-height: 20px; font-family: 'Open Sans' sans-serif; color: white;"
        >
          Use the above search form to instantly compare flight prices and book
          online now. You can also book online and pay in-store at your nearest
          Pick ‘n Pay to earn Smart Shopper points!
        </p>
        <p
          style="margin: 0 0 10px; line-height: 20px; font-family: 'Open Sans' sans-serif; color: white;"
        >
          Why choose FlightSite? Voted Africa’s Leading Online Travel Agency a
          record 7 times, you can rest assured that your travel booking is in
          safe hands. We also serve as the dedicated online travel desk for a
          range of top South African companies.
        </p>
        <p
          style="margin: 0 0 10px; line-height: 20px; font-family: 'Open Sans' sans-serif; color: white;"
        >
          Our fast, intuitive search engine helps you compare flight prices on
          airlines such as
          <a
            style="color: #fff;"
            href="https://travel.flightsite.co.za/travel/airlines/south-african-airways/"
            target="_self"
            >SAA</a
          >, British Airways, Turkish Airlines,
          <a
            style="color: #fff;"
            href="https://travel.flightsite.co.za/travel/airlines/flysafair-flights/"
            target="_self"
            >FlySafair</a
          >, Emirates, and Qatar Airways within seconds.
        </p>
      </div>
    </div>

    <div
      class="container"
      style="width: 90%; max-width: 1200px; padding: 50px auto;"
    >
      <h2 class="grey_h2" style="text-transform: uppercase; margin-top: 30px;">
        Popular Routes
      </h2>
      <div
        style="background: #0077b7; width: 80px; height: 6px; display: block; margin-bottom: 30px;"
      ></div>
      <div class="row" style="margin-bottom:50px;">
        <div>
          <div class="col-md-3 popular-routes" :style="route0CSS">
            <a
              href="https://travel.flightsite.co.za/travel/routes/johannesburg-cape-town/"
              target="_self"
            >
              <div style="text-align: center">
                <div
                  style="line-height: 1; width: 100%; left: 0px; bottom: 0px; font-weight: bold;font-size: 30px; position: absolute; color: #fff; padding: 30px 15px; text-transform: uppercase; font-weight: normal"
                >
                  <span style="font-size: 16px; color:#fff"
                    >JOHANNESBURG TO</span
                  ><br /><span style="color:#fff">Cape Town</span><br />
                </div>
              </div>
            </a>
          </div>
          <div class="col-md-3 popular-routes" :style="route1CSS">
            <a
              href="https://travel.flightsite.co.za/travel/routes/flights-johannesburg-durban/"
              target="_self"
            >
              <div style="text-align: center">
                <div
                  style="line-height: 1; width: 100%; left: 0px; bottom: 0px; font-weight: bold;font-size: 30px; position: absolute; color: #fff; padding: 30px 15px; text-transform: uppercase; font-weight: normal"
                >
                  <span style="font-size: 16px; color:#fff"
                    >JOHANNESBURG TO</span
                  ><br /><span style="color:#fff">Durban</span><br />
                </div>
              </div>
            </a>
          </div>
          <div class="col-md-3 popular-routes" :style="route2CSS">
            <a
              href="https://travel.flightsite.co.za/travel/routes/flights-durban-johannesburg/"
              target="_self"
            >
              <div style="text-align: center">
                <div
                  style="line-height: 1; width: 100%; left: 0px; bottom: 0px; font-weight: bold;font-size: 30px; position: absolute; color: #fff; padding: 30px 15px; text-transform: uppercase; font-weight: normal"
                >
                  <span style="font-size: 16px; color:#fff">Durban TO</span
                  ><br /><span style="color:#fff">Johannesburg</span><br />
                </div>
              </div>
            </a>
          </div>
          <div class="col-md-3 popular-routes" :style="route3CSS">
            <a
              href="https://travel.flightsite.co.za/travel/routes/flights-cape-town-port-elizabeth/"
              target="_self"
            >
              <div style="text-align: center">
                <div
                  style="line-height: 1; width: 100%; left: 0px; bottom: 0px; font-weight: bold;font-size: 30px; position: absolute; color: #fff; padding: 30px 15px; text-transform: uppercase; font-weight: normal"
                >
                  <span style="font-size: 16px; color:#fff"
                    >JOHANNESBURG TO</span
                  ><br /><span style="color:#fff">Port Elizabeth</span><br />
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="my-max" v-if="packages !== undefined" :style="packageCSS" style="background-color: #eaeaea;">
      <div
        class="container"
        style="width: 90%; max-width: 1200px; padding: 50px auto;"
      >
        <h2
          class="grey_h2"
          style="text-transform: uppercase; margin-top: 30px;"
        >
          POPULAR TRAVEL PACKAGES
        </h2>
        <div
          style="background: #0077b7; width: 80px; height: 6px; display: block; margin-bottom: 30px;"
        ></div>

        <div class="container">
          <div class="row">
            <div
              class="MultiCarousel"
              data-items="1,3,4,4"
              data-slide="1"
              id="MultiCarousel"
              data-interval="1000"
            >
              <button class="btn btn-primary leftLst"><b-icon icon="chevron-left"></b-icon></button>
              <button class="btn btn-primary rightLst"><b-icon icon="chevron-right"></b-icon></button>

              <div 
              class="MultiCarousel-inner">
                <div
                v-for="(pck, index) in packages"
              :key="index"
                  class="item col-md-3"
                  style="min-height: 495px; margin-top: 30px; padding: 0px; margin-bottom: 15px;"
                >
                  <div style="background-color: #f2f2f2; padding: 0px;">
                    <a
                      :href="'https://holidays.flightsite.co.za/travel-packages/detail.php?package=' + pck.package_id"
                      target="_self"
                      style="text-decoration:none"
                    >
                      <div
                        style="min-height: 285px; background-size: cover; display: block; position: relative; background-position: center center;"
                        :style="pck.imageObj"
                      ></div>
                      <div
                        style="padding: 15px 15px 0px 15px; font-size: 22px; color: #333;"
                      >
                        <div
                          style="min-height: 65px; font-size: 22px;
    color: #333;"
                        >
                          {{pck.intro}}
                        </div>
                        <span style="font-size: 16px; color: #CCC;"
                          >{{pck.destination}}</span
                        >
                      </div>
                    </a>
                    <hr style="margin-top: 10px; margin-bottom: 10px;" />
                    <div
                      class="col-md-6"
                      style="padding-right: 0px; padding-top: 5px;"
                    >
                      <span style="font-size: 18px; color: #333;"
                        >{{pck.price_from}}</span
                      >
                    </div>
                    <div class="col-md-6">
                      <a
                        :href="'https://holidays.flightsite.co.za/travel-packages/detail.php?package=' + pck.package_id"
                        class="pull-right"
                        style="background-color: #0977b9; color: #fff; text-decoration: none; margin-bottom: 15px;padding: 8px;"
                        target="_self"
                        >More details</a
                      >
                    </div>
                    <br clear="all" />
                  </div>
                </div>
                <div
                  class="item active col-md-3"
                  style="min-height: 535px; margin-top: 30px; padding: 0px; margin-bottom: 15px;"
                >
                  <div style="background-color: transparent; padding: 0px;">
                    <a
                      href="https://holidays.flightsite.co.za/travel-packages/"
                      target="_self"
                      style="text-decoration:none"
                    >
                      <img src="@/assets/images/more-packages.webp" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="container"
      style="width: 90%; max-width: 1200px; padding: 50px auto;"
    >
      <h2 class="grey_h2" style="text-transform: uppercase; margin-top: 30px;">
        Popular Destinations
      </h2>
      <div
        style="background: #0077b7; width: 80px; height: 6px; display: block; margin-bottom: 30px;"
      ></div>
      <div class="row" style="margin-bottom:50px;">
        <div>
          <div class="col-md-6 row">
            <div class="col-md-12 no-mobile-margin-sm">
              <div
                style="position: relative; height: 200px; display: block; background-size: cover; width: 100%; margin-bottom: 30px;"
                :style="bushBreakCSS"
              >
                <a
                  href="https://holidays.flightsite.co.za/travel-packages/?experience=bush_breaks"
                  target="_self"
                  class="popular_pks"
                  ><div class="popular_pks">
                    <h3>Bush Breaks</h3>
                  </div></a
                >
              </div>
            </div>
            <div class="col-md-6">
              <div
                style="height: 200px; display: block; background-size: cover; width: 100%"
                :style="thailandCSS"
              >
                <a
                  href="https://holidays.flightsite.co.za/travel-packages/?destination=thailand"
                  target="_self"
                  class="popular_pks"
                  ><div class="popular_pks">
                    <h3>Thailand</h3>
                  </div></a
                >
              </div>
            </div>
            <div class="col-md-6">
              <div
                style="height: 200px; display: block; background-size: cover; width: 100%"
                :style="northAmericaCSS"
              >
                <a
                  href="https://holidays.flightsite.co.za/travel-packages/?destination=north_america"
                  target="_self"
                  class="popular_pks"
                  ><div class="popular_pks">
                    <h3>North America</h3>
                  </div></a
                >
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div
              style="display: block; background-size: cover;"
              :style="dohaCSS"
              class="tablet-maximum"
            >
              <a
                href="https://holidays.flightsite.co.za/travel-packages/?destination=Dubai"
                target="_self"
                class="popular_pks_430"
                ><div class="popular_pks_430">
                  <h3>Dubai</h3>
                </div></a
              >
            </div>
          </div>
          <div class="col-md-3">
            <div
              style="height: 200px; display: block; background-size: cover; margin-bottom: 30px;"
              :style="europeCSS"
              class="no-mobile-margin-bg"
            >
              <a
                href="https://holidays.flightsite.co.za/travel-packages/?destination=europe"
                target="_self"
                class="popular_pks"
                ><div class="popular_pks">
                  <h3>Europe</h3>
                </div></a
              >
            </div>

            <div
              style="height: 200px; display: block; background-size: cover;"
              :style="mauritiusCSS"
            >
              <a
                href="https://holidays.flightsite.co.za/travel-packages/?destination=mauritius"
                target="_self"
                class="popular_pks"
                ><div class="popular_pks">
                  <h3>Mauritius</h3>
                </div></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :style="cssProps">
      <div
        class="container"
        style="width: 90%; max-width: 1200px; padding: 50px auto;"
      >
        <div
          class="col-md-6"
          style="padding: 60px 30px; color: #fff; text-align: center;"
        >
          <h1 class="my-h1">
            Looking for more info?
          </h1>
          <p style="color: #fff">
            <br />Use the above search form to instantly compare flight prices
            and book online now. You can also book online and pay in-store at
            your nearest Pick ‘n Pay to earn Smart Shopper points!<br /><br />
          </p>
          <div
            style="display: flex; flex-wrap: wrap; justify-content: space-around; margin-top: 10px;"
          >
            <a
              href="#"
              data-toggle="modal"
              data-target="#packageEnquiryModal"
              class="search_button"
              style="white-space: nowrap; text-transform: uppercase;"
              >Enquire Now</a
            >
            <a
              href="https://travel.flightsite.co.za/travel/contact-us/"
              target="_self"
              class="search_button"
              style="white-space: nowrap; text-transform: uppercase;"
              >Contact Us</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Api from "@/services/Api.service.js";
import $ from "jquery";


export default {
  name: "HomeContent",
  data: function() {
    return {
      packages: undefined,
      cssProps: {
        backgroundImage: `url(${require("@/assets/images/contact-us-1.webp")})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundColor: `rgba(0,0,0,.5)`
      },
      welcomeCSS: {
        backgroundImage: `url(${require("@/assets/images/welcome-image.webp")})`,
        backgroundSize: "cover"
      },
      packageCSS: {
        backgroundImage: `url(${require("@/assets/images/packages-homepage-bg.webp")})`,
        backgroundSize: "cover"
      },
      bushBreakCSS: {
        backgroundImage: `url(${require("@/assets/images/destinations-africa.webp")})`
      },
      thailandCSS: {
        backgroundImage: `url(${require("@/assets/images/destinations-asia.webp")})`
      },
      northAmericaCSS: {
        backgroundImage: `url(${require("@/assets/images/destinations-north-america.webp")})`
      },
      mauritiusCSS: {
        backgroundImage: `url(${require("@/assets/images/destinations-mauritius.webp")})`
      },
      europeCSS: {
        backgroundImage: `url(${require("@/assets/images/destinations-europe.webp")})`
      },
      dohaCSS: {
        backgroundImage: `url(${require("@/assets/images/destination-dubai.jpg")})`
      },
      route0CSS: {
        backgroundImage: `url(${require("@/assets/images/route-cape-town.webp")})`
      },
      route1CSS: {
        backgroundImage: `url(${require("@/assets/images/route-durban.webp")})`
      },
      route2CSS: {
        backgroundImage: `url(${require("@/assets/images/route-johannesburg.webp")})`
      },
      route3CSS: {
        backgroundImage: `url(${require("@/assets/images/route-port-elizabeth.webp")})`
      }
    };
  },
  methods: {
    async fetchPackages() {
      let result = await Api.packageList( 
      {
        "limit":"8",
        "specials":"show_in_home",
        "dims":"800x450"
      });
      if (result) {
        result.data.content.packages.forEach(element => {
          element.imageObj = {
            backgroundImage: `url(https://packages.flightsite.co.za${element.images[0]})`
          };
        });
        this.packages = result.data.content.packages;
      }
    },
  },

  watch: {
    packages(value) {
      if (value === undefined) {
        return ;
      }

      setTimeout(function(){
        $(document).ready(function() {
          var itemsMainDiv = ".MultiCarousel";
          var itemsDiv = ".MultiCarousel-inner";
          var itemWidth = "";
          $(".leftLst, .rightLst").click(function() {
            var condition = $(this).hasClass("leftLst");
            if (condition) click(0, this);
            else click(1, this);
          });
          
          ResCarouselSize();
          $(window).resize(function() {
            ResCarouselSize();
          });
          //this function define the size of the items
          function ResCarouselSize() {
            var incno = 0;
            var dataItems = "data-items";
            var itemClass = ".item";
            var id = 0;
            var btnParentSb = "";
            var itemsSplit = "";
            var sampwidth = $(itemsMainDiv).width();
            var bodyWidth = $("body").width();
            $(itemsDiv).each(function() {
              id = id + 1;
              var itemNumbers = $(this).find(itemClass).length;
              btnParentSb = $(this)
                .parent()
                .attr(dataItems);
              itemsSplit = btnParentSb.split(",");
              $(this)
                .parent()
                .attr("id", "MultiCarousel" + id);

              if (bodyWidth >= 1200) {
                incno = itemsSplit[3];
                itemWidth = sampwidth / incno;
              } else if (bodyWidth >= 992) {
                incno = itemsSplit[2];
                itemWidth = sampwidth / incno;
              } else if (bodyWidth >= 768) {
                incno = itemsSplit[1];
                itemWidth = sampwidth / incno;
              } else {
                incno = itemsSplit[0];
                itemWidth = sampwidth / incno;
              }
              $(this).css({
                transform: "translateX(0px)",
                width: itemWidth * itemNumbers
              });
              $(this)
                .find(itemClass)
                .each(function() {
                  $(this).outerWidth(itemWidth);
                });

              $(".leftLst").addClass("over");
              $(".rightLst").removeClass("over");
            });
          }

          //this function used to move the items
          function ResCarousel(e, el, s) {
            var leftBtn = ".leftLst";
            var rightBtn = ".rightLst";
            var translateXval = "";
            var divStyle = $(el + " " + itemsDiv).css("transform");
            var values = divStyle.match(/-?[\d\.]+/g);
            var xds = Math.abs(values[4]);
            if (e == 0) {
              translateXval = parseInt(xds) - parseInt(itemWidth * s);
              $(el + " " + rightBtn).removeClass("over");

              if (translateXval <= itemWidth / 2) {
                translateXval = 0;
                $(el + " " + leftBtn).addClass("over");
              }
            } else if (e == 1) {
              var itemsCondition =
                $(el)
                  .find(itemsDiv)
                  .width() - $(el).width();
              translateXval = parseInt(xds) + parseInt(itemWidth * s);
              $(el + " " + leftBtn).removeClass("over");

              if (translateXval >= itemsCondition - itemWidth / 2) {
                translateXval = itemsCondition;
                $(el + " " + rightBtn).addClass("over");
              }
            }
            $(el + " " + itemsDiv).css(
              "transform",
              "translateX(" + -translateXval + "px)"
            );
          }

          //It is used to get some elements from btn
          function click(ell, ee) {
            var Parent =
              "#" +
              $(ee)
                .parent()
                .attr("id");
            var slide = $(Parent).attr("data-slide");
            ResCarousel(ell, Parent, slide);
          }
        });
        }, 1000);
      }
  },

  mounted() {
    this.fetchPackages();
  }
};

</script>
<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

#home-content {
  border-top: 4px solid #0977b9;
  width: 100vw;
  background: $light;
}

.my-max {
  max-height: 712px;
  overflow: hidden;
}

.MultiCarousel {
  float: left;
  overflow: hidden;
  padding: 30px 0px 0px;
  width: 100%;
  position: relative;
}

.MultiCarousel .MultiCarousel-inner {
  transition: 1s ease all;
  float: left;
}

.MultiCarousel .MultiCarousel-inner .item {
  float: left;
}

.MultiCarousel .MultiCarousel-inner .item > div {
  padding: 10px;
  margin: 10px;
  background: #f1f1f1;
  color: #666;
}

.MultiCarousel .leftLst,
.MultiCarousel .rightLst {
  position: absolute;
  border-radius: 0%;
  top: 10px;
}

.MultiCarousel .leftLst {
  right: 40px;
}

.MultiCarousel .rightLst {
  right: 0;
}

.MultiCarousel .leftLst.over,
.MultiCarousel .rightLst.over {
  pointer-events: none;
  background: #ccc;
}

.popular-routes {
  background-size: cover;
  display: block;
  position: relative;
  min-height: 390px;
}

.header_container {
  width: 100%;
  text-align: center;
  text-transform: uppercase;
  font-family: "Open Sans", sans-serif;
}

.large_header {
  font-weight: bold;
  font-size: 70px;
  font-family: "Open Sans", sans-serif;
  line-height: 1;
}

// .buttons {
//   display: flex;
//   justify-content: right;
//   width: 100%;
// }

.popular_pks {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.3);
  height: 200px;
  display: block;
  z-index: 9999;
  width: 100%;
  transition: background-color 0.5s ease;
  background-size: cover;
  width: 100%;
}

.popular_pks_430 {
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.3);
  height: 430px;
  display: block;
  z-index: 9999;
  width: 100%;
  transition: background-color 0.5s ease;
  background-size: cover;
  width: 100%;
}

.popular_pks:hover,
.popular_pks_430:hover {
  background-color: rgba(0, 0, 0, 0.1);
  transition: 0.5;
  text-decoration: none;
}

.popular_pks h3 {
  text-transform: uppercase;
  font-size: 24px;
  color: #fff;
  text-align: center;
  padding-top: 80px;
}

.popular_pks_430 h3 {
  text-transform: uppercase;
  font-size: 24px;
  color: #fff;
  text-align: center;
  padding-top: 190px;
}

.my-h1 {
  color: #fff;
  text-transform: uppercase;
  text-align: center;
  font-size: 30px;
  font-family: "Hind", sans-serif !important;
}

.my-p {
  font-family: "Open Sans", sans-serif;
}

.grey_h2 {
  color: #484848;
  text-transform: uppercase;
  margin-top: 30px;
  font-weight: 500;
  font-size: 30px;
  letter-spacing: 1px;
  font-family: "Hind", sans-serif !important;
}

.search_button {
  background-color: #0977b9;
  padding: 8px 25px;
  color: #fff;
  border-radius: 2px;
  font-size: 16px;
  border: 2px solid #0977b9;
  text-shadow: none;
  white-space: nowrap;
  max-height: 42px;
  width: min-content;
}

.search_button:hover {
  background-color: #fff;
  padding: 8px 25px;
  color: #0977b9;
  border: 2px solid #0977b9;
  text-decoration: none;
  border-radius: 2px;
  font-size: 16px;
}

.reference-bar {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: flex-end;
  max-width: 1080px;
  margin: auto;
  flex-wrap: wrap;
  padding: $standard-padding;
}

.home-icon {
  text-align: center;
  padding-top: 20px;
  width: 100%;
}

@media (min-width: 781px) {
  .home-icon {
    width: unset;
  }
}
</style>
